<template>
  <div>
    <div>
      <el-form ref="copyObjForm" :model="copyObj" label-width="80px">
        <div class="center mgb10" v-if="source == 'bargainIndex'">
          <el-radio-group v-model="copyObj.type" size="small">
            <el-radio-button label="order">
              复制在本订单下生成新的订单项
            </el-radio-button>
            <el-radio-button label="bargain">复制生成新的订单</el-radio-button>
          </el-radio-group>
        </div>
        <el-form-item
          :prop="'serialNo'"
          :rules="[
            {
              required: true,
              validator: validateSerialNo,
              trigger: 'blur',
            },
          ]"
          :label="$t('order.serialNo')"
        >
          <el-input
            size="small"
            v-model.trim="copyObj.serialNo"
            :placeholder="$t('prompt.alphabetNumberLine')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.handOverAt')">
          <el-date-picker
            size="small"
            v-model="copyObj.handOverAt"
            type="date"
            style="width: 100%"
            :picker-options="pickerTodayAfterTime"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="right pd20">
      <el-button
        size="small"
        type="primary"
        :loading="submitDoing"
        @click="submit"
      >
        {{ $t("text.submit") }}
      </el-button>
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Bargain from "@/api/bargain.js";
import Order from "@/api/order.js";

export default {
  props: {
    id: Number,
    source: String,
    serialNo: String,
  },
  mixins: [page],
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("bargain.serialNo")]))
        );
        return;
      }
      if (!Util.regexAlphabetNumberLine(value)) {
        callback(new Error(self.$t("prompt.regexAlphabetNumberLine")));
        return;
      }
      Bargain.findBySerialNo({ serialNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("bargain.serialNo")]))
          );
        } else {
          Order.findBySerialNo({ serialNo: value }).then(function (res) {
            if (res.data.code === 200) {
              callback(
                new Error(self.$t("rules.exist", [self.$t("order.serialNo")]))
              );
            } else {
              callback();
            }
          });
        }
      });
    };

    return {
      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      validateSerialNo: validateSerialNo,
      copyObj: {
        serialNo: Util.serialNo(),
        handOverAt: null,
        type: "bargain",
      },
      submitDoing: false,
    };
  },
  created() {
    const self = this;
    if (self.source == "newedOrders") {
      self.copyObj.type = "order";
      self.copyObj.serialNo = self.serialNo + "Copy";
    }
  },
  methods: {
    submit() {
      const self = this;
      self.$refs.copyObjForm.validate((valid) => {
        if (valid) {
          if (self.copyObj.handOverAt != null) {
            self.copyObj.handOverAt = Util.formatDate(self.copyObj.handOverAt);
          }
          self.submitDoing = true;
          if (self.copyObj.type == "bargain") {
            Order.copyToNewBargain(self.id, self.copyObj).then(function (res) {
              self.submitDoing = false;
              if (res.status === 200) {
                self.$emit("updated");
                self.sysResult(res.data);
                self.$eventHub.$emit("OrderCopyToNewBargain");
              } else {
                self.sysError();
              }
            });
          } else {
            Order.copy(self.id, self.copyObj).then(function (res) {
              self.submitDoing = false;
              if (res.status === 200) {
                self.$emit("updated");
                self.sysResult(res.data);
                self.$eventHub.$emit("orderCopy");
              } else {
                self.sysError();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
